import { MantineThemeOverride } from "@mantine/core";
import { getThemeColors, primaryColors, ThemeMode } from "./colors";
import { TickitackaTheme } from "./types";

// 테마 색상을 생성하는 함수
const createThemeColors = (mode: ThemeMode) => {
    const colors = getThemeColors(mode);

    const tickitackaTheme: TickitackaTheme = {
        background: colors.background.default,
        backgroundBright: colors.background.bright,
        backgroundDim: colors.background.dim,

        surface: colors.surface.default,
        surfaceLowest: colors.surface.lowest,
        surfaceLow: colors.surface.low,
        surfaceHigh: colors.surface.high,
        surfaceHighest: colors.surface.highest,

        primary: primaryColors.primary.main,
        primaryLight: primaryColors.primary.light,
        primaryDark: primaryColors.primary.dark,
        primaryVariant: primaryColors.primaryVariant.main,

        onSurface: colors.onSurface.default,
        onSurfaceVariant: colors.onSurface.variant,
        outline: colors.outline.default,
        outlineVariant: colors.outline.variant,

        scrim: colors.scrim,
    };

    return {
        other: {
            // other 객체 안에 tickitacka 객체를 넣음
            tickitacka: tickitackaTheme,
        },
    };
};

// 초기 테마 설정 (라이트 모드)
export const theme: MantineThemeOverride = createThemeColors("light");

// 테마 업데이트 함수 export
export const updateThemeColors = (mode: ThemeMode): MantineThemeOverride =>
    createThemeColors(mode);
